import {GlobalExternalLinkEnum} from 'presentation/constants';
import {useGetReferralDetailsQuery} from 'presentation/pages/private/my-referrals/queries/useGetReferralsDetails';

export const useReferralDetailsDrawer = (cdSenha?: string) => {
	const {data, isLoading, error, refetch} = useGetReferralDetailsQuery(cdSenha);
	const locationLink = `${GlobalExternalLinkEnum.GOOGLE_MAPS}/?q=${data?.prestador?.endereco}`;

	return {data, isLoading, locationLink, error, refetch};
};
